export default __webpack_public_path__ + "static/media/gallery_02.97747cf5.jpg";